import axios from 'axios';
import i18n from '@/i18n';

export default {
  baseURL: process.env.BASE_URL + 'api/administration',

  getClientSettings(clientId) {
    return axios.get('client-settings',
      { 
        baseURL: this.baseURL,
        params: {
          'client-id': clientId
        }
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        console.log(error);
        return Promise.reject(error);
      });
  },

  setClientSettings(clientSettings) {
    return axios.put('client-settings', clientSettings,
      { 
        baseURL: this.baseURL,
      })
      .then(function (response) {
        return response;
      });
  },

  getThemes() {
    return axios.get('themes',
      { 
        baseURL: this.baseURL
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        console.log(error);
        return Promise.reject(error);
      });
  },

  getCheckReportFileNameSamples(clientId, template) {
    return axios.get('get-check-report-filename-samples',
      { 
        baseURL: this.baseURL,
        params: {
          'client-id': clientId,
          'template': template
        }
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        console.log(error);
        return Promise.reject(error);
      });
  },

  getCheckReportPreview(clientId, clientSettings, theme, thresholds, options, cancelToken) {
    return axios.post('get-check-report-preview', {
        'ClientId': clientId,
        'ClientSettings': clientSettings,
        'Theme': theme,
        'Thresholds': thresholds,
        'LocalizationId': (options && options.localizationId) ? options.localizationId : i18n.locale,
      },
      {
        baseURL: this.baseURL,
        responseType: 'blob',
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function (response) {
        return response;
      });
  },

  getSurveySettings(surveyId) {
    return axios.get('survey-settings',
      { 
        baseURL: this.baseURL,
        params: {
          'survey-id': surveyId
        }
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        console.log(error);
        return Promise.reject(error);
      });
  },

  setSurveySettings(surveySettings) {
    return axios.put('survey-settings', surveySettings,
      { 
        baseURL: this.baseURL,
      })
      .then(function (response) {
        return response;
      });
  },

  getGeneralSettings() {
    return axios.get('general-settings',
      { 
        baseURL: this.baseURL
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        console.log(error);
        return Promise.reject(error);
      });
  },

  setGeneralSettings(settings) {
    return axios.put('general-settings', settings,
      { 
        baseURL: this.baseURL,
      })
      .then(function (response) {
        return response;
      });
  },
}